import { createContext, useContext } from 'react';
import type { Locale } from '@/strings/types';

/**
 * The locale every view inside an AppShell reads.
 *
 * A context rather than a prop threaded through each view, and deliberately NOT
 * `useLocale()`: a view's language must follow the SHELL it is inside, not the
 * route the page happens to be on. Storybook renders both locales' shells under
 * one router, and the hero's fallback path can render an English shell under a
 * still-Arabic <html> — a view reading the route would go Arabic inside an
 * English frame.
 *
 * Views are AppShell's `children`, so they are created by the caller but
 * RENDERED inside the provider, which is what makes the context resolve.
 *
 * It lives in its own module rather than beside AppShell because a file that
 * exports both a component and a hook breaks React Fast Refresh, and the repo
 * lints that as an error (`--max-warnings 0`).
 */
export const ShellLocaleContext = createContext<Locale>('en');

/** The locale of the enclosing AppShell. Defaults to 'en' outside one. */
export function useShellLocale(): Locale {
  return useContext(ShellLocaleContext);
}
